import { Text, type TextStyle, View } from 'react-native'

import { convertLineHeight, styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'flex-start',
      gap: theme.spacingInlineHalfpulse,
    },
    variants: {},
  }
})

export const Label = styled(Text, theme => {
  const semiboldFontWeight = String(
    theme.fontWeightSemibold
  ) as TextStyle['fontWeight']

  return {
    base: {
      color: theme.colorTextDangerAlternative,
      fontWeight: semiboldFontWeight,
      fontFamily: 'RDModern-SemiBold',
      fontSize: theme.fontSizeThreepulse,
      paddingLeft: theme.spacingInlineOnepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightDefault
      ),
      textAlign: 'left',
      textAlignVertical: 'top',
    },
    variants: {},
  }
})
